// @flow
import { combineActions, handleActions } from 'redux-actions';

import { upsertResource, upsertResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';
import { mkFiltersStore } from './types';

const reducer = handleActions({

  // Called when triggering a CRUD operation on transactions. Sagas are also
  // expected to handle the action by initiating the CRUD operation with QCS.
  //
  [combineActions(
    actions.getFilters,
    actions.createFilter,
    actions.updateFilter,
    actions.deleteFilter,
  )]: (state) => state,

  // Called when a CRUD operation is successful on transactions. The success
  // action is triggered by the Sagas.
  [combineActions(
    actions.getFiltersSuccess
  )]: (state, { payload: data }) => upsertResources(state, data),

  // Called when a CRUD operation is successful on transactions. The success
  // action is triggered by the Sagas.
  [combineActions(
    actions.createFilterSuccess,
    actions.updateFilterSuccess,
    actions.deleteFilterSuccess
  )]: (state, { payload: filterToUpsert }) => upsertResource(state, filterToUpsert),

  // Called when a CRUD operation fails on transactions. The failure action
  // is triggered by Sagas.
  [combineActions(
    actions.getFiltersFailure,
    actions.createFilterFailure,
    actions.updateFilterFailure,
    actions.deleteFilterFailure
  )]: (state, { payload: _error }) => state,

}, mkFiltersStore());

export const REDUCER_KEY = 'filterStore';
export default reducer;
